import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchContent } from "@/lib/api";
import { FadeUp } from "@/components/Reveal";
import { KanthaStitch } from "@/components/Motifs";

export default function JournalDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setArticle(null);
    fetchContent(`/journal/${slug}`)
      .then((data) => (data && data.slug ? setArticle(data) : setError(true)))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <main className="pt-40 pb-40 text-center" data-testid="article-not-found">
        <p className="font-serif text-4xl text-ink">This page of the journal is missing.</p>
        <Link to="/journal" className="link-underline inline-block mt-6 text-[11px] tracking-[0.25em] uppercase text-alta">Back to the journal</Link>
      </main>
    );
  }
  if (!article) {
    return <main className="pt-40 pb-40 text-center text-ink/50 font-light" data-testid="article-loading">Opening the journal…</main>;
  }

  return (
    <main data-testid="journal-detail-page" className="pt-24">
      <article className="max-w-[900px] mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-24">
        <FadeUp>
          <p className="text-[11px] tracking-[0.3em] uppercase text-alta mb-6">
            {article.category}{article.date ? ` · ${article.date}` : ""}
          </p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.08]">
            {article.title}
          </h1>
          <p className="mt-6 font-serif italic text-xl text-ink/60 font-light">{article.excerpt}</p>
        </FadeUp>

        <motion.div
          initial={{ opacity: 0, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 editorial-frame"
        >
          <img src={article.image} alt={article.title} className="w-full aspect-[16/9] object-cover" />
        </motion.div>

        <FadeUp className="mt-14">
          {article.content.split("\n\n").map((para, i) => (
            <p key={i} className={`font-light leading-loose text-ink/80 mb-8 ${i === 0 ? "font-serif text-xl md:text-2xl text-walnut" : "text-base md:text-lg"}`}>
              {para}
            </p>
          ))}
          <KanthaStitch className="my-12" />
          <div className="flex items-center justify-between">
            <p className="font-bengali text-2xl text-terracotta/70">— ইপ্সিতা</p>
            <Link to="/journal" data-testid="article-back-link" className="link-underline text-[11px] font-medium tracking-[0.25em] uppercase text-ink">
              All Stories
            </Link>
          </div>
        </FadeUp>
      </article>
    </main>
  );
}
